var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInventory = function SvgInventory(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.3 11.111h5.4m5.1-3.555v10.666c0 .982-.805 1.778-1.8 1.778H6c-.995 0-1.8-.796-1.8-1.778V7.556m15.9 0H3.9a.895.895 0 0 1-.9-.89V4.89c0-.49.403-.889.9-.889h16.2c.497 0 .9.398.9.889v1.778c0 .49-.403.889-.9.889Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInventory);
export default ForwardRef;